import request from '../utils/request'

export function searchVisitLog(params){
    return request({
        method: 'get',
        url: '/visitLog/searchVisitLog',
        params:params
    })
}

export function saveVisitLog(params){
    return request({
        method: 'post',
        url: '/visitLog/myHumbleAbode',
        data:params
    })
}

export function getStatisticalData(){
    return request({
        method: 'get',
        url: '/visitLog/getStatisticalData'
    })
}

export function getTotalVisits(){
    return request({
        method: 'get',
        url: '/visitLog/getTotalVisits'
    })
}